import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Enumerable from 'linq';
import { SponsorshipLandingPageViewModel } from 'src/app/_models/generatedModels';
import { AnalyticsService } from 'src/app/_services/analytics.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ConferenceCMSService, OrganizationService, SponsorshipsService } from 'src/app/_services/generatedServices';

@Component({
  selector: 'bxl-view-landing-page',
  templateUrl: 'view-landing-page.component.html',
})
export class ViewLandingPageComponent implements OnInit {
  initialized = false;
  homeRoute = 'exhibits';

  page: SponsorshipLandingPageViewModel;
  constructor(private title: AnalyticsService, public auth: AuthenticationService, private route: ActivatedRoute, private router: Router, private orgService: SponsorshipsService, private cmsService: ConferenceCMSService) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((parentParam) => {
      var pageId = +parentParam.get('pageId');
      var conferenceSlug = parentParam.get('conferenceSlug');
      this.cmsService.getWebsitePagesForConference(conferenceSlug).subscribe((pages) => {
        var page = Enumerable.from(pages)
          .where((x) => x.elements.find((x) => x.pageElementType.toString() == 'ExhibitListing') != null)
          .firstOrDefault();

        this.homeRoute = page.slug;
        this.orgService.getLandingPageForConference(pageId, conferenceSlug).subscribe((page) => {
          this.page = page;
          this.initialized = true;
        });
      });
    });
  }
}
